import {
    NOTIFICATION_ADMIN_LIST_FAIL,
    NOTIFICATION_ADMIN_LIST_REQUEST,
    NOTIFICATION_ADMIN_LIST_SUCCESS,
    NOTIFICATION_CREATE_CLEAR,
    NOTIFICATION_CREATE_FAIL,
    NOTIFICATION_CREATE_REQUEST,
    NOTIFICATION_CREATE_SUCCESS,
    NOTIFICATION_DELETE_CLEAR,
    NOTIFICATION_DELETE_FAIL,
    NOTIFICATION_DELETE_REQUEST,
    NOTIFICATION_DELETE_SUCCESS,
    NOTIFICATION_LIST_FAIL,
    NOTIFICATION_LIST_REQUEST,
    NOTIFICATION_LIST_SUCCESS,
    NOTIFICATION_MARK_ALL_READ_SUCCESS,
    NOTIFICATION_MARK_READ_SUCCESS,
    NOTIFICATION_UNREAD_COUNT_FAIL,
    NOTIFICATION_UNREAD_COUNT_REQUEST,
    NOTIFICATION_UNREAD_COUNT_SUCCESS
} from '../constants/notificationConstant'

export const createNotificationReducer = (state = {}, action) => {
    switch(action.type) {
        case NOTIFICATION_CREATE_REQUEST:
            return { loading: true, error: null }
        case NOTIFICATION_CREATE_SUCCESS:
            return { loading: false, error: null, message: action.payload, success: true }
        case NOTIFICATION_CREATE_FAIL:
            return { loading: false, error: action.payload }
        case NOTIFICATION_CREATE_CLEAR:
            return { loading: false, error: null, message: null, success: null }
        default:
            return state
    }
}

export const listNotificationsReducer = (state = {}, action) => {
    switch(action.type) {
        case NOTIFICATION_LIST_REQUEST:
            return { loading: true, error: null }
        case NOTIFICATION_LIST_SUCCESS:
            return {
                loading: false,
                error: null,
                notifications: action.payload.notifications,
                count: action.payload.notificationsCount,
                page: action.payload.page
            }
        case NOTIFICATION_MARK_READ_SUCCESS:
            return {
                ...state,
                notifications: state.notifications
                    ? state.notifications.map(notification => notification._id === action.payload._id
                        ? action.payload
                        : notification)
                    : state.notifications
            }
        case NOTIFICATION_MARK_ALL_READ_SUCCESS:
            return { ...state }
        case NOTIFICATION_LIST_FAIL:
            return { loading: false, error: action.payload }
        default:
            return state
    }
}

export const listAdminNotificationsReducer = (state = {}, action) => {
    switch(action.type) {
        case NOTIFICATION_ADMIN_LIST_REQUEST:
            return { loading: true, error: null }
        case NOTIFICATION_ADMIN_LIST_SUCCESS:
            return {
                loading: false,
                error: null,
                notifications: action.payload.notifications,
                count: action.payload.notificationsCount,
                page: action.payload.page
            }
        case NOTIFICATION_ADMIN_LIST_FAIL:
            return { loading: false, error: action.payload }
        default:
            return state
    }
}

export const notificationUnreadCountReducer = (state = { count: 0 }, action) => {
    switch(action.type) {
        case NOTIFICATION_UNREAD_COUNT_REQUEST:
            return { ...state, loading: true, error: null }
        case NOTIFICATION_UNREAD_COUNT_SUCCESS:
            return { loading: false, error: null, count: action.payload }
        case NOTIFICATION_MARK_ALL_READ_SUCCESS:
            return { loading: false, error: null, count: 0 }
        case NOTIFICATION_UNREAD_COUNT_FAIL:
            return { ...state, loading: false, error: action.payload }
        default:
            return state
    }
}

export const deleteNotificationReducer = (state = {}, action) => {
    switch(action.type) {
        case NOTIFICATION_DELETE_REQUEST:
            return { loading: true, error: null }
        case NOTIFICATION_DELETE_SUCCESS:
            return { loading: false, error: null, message: action.payload, success: true }
        case NOTIFICATION_DELETE_FAIL:
            return { loading: false, error: action.payload }
        case NOTIFICATION_DELETE_CLEAR:
            return { loading: false, error: null, message: null, success: null }
        default:
            return state
    }
}
